export default "__VITE_ASSET__CZx2KoSH__"